import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  unselected: {
    width: "20px",
    height: "20px",
    border: `1px solid ${theme.palette.grey[600]}`,
    boxSizing: "border-box",
    borderRadius: "10px",
  },
  selected: {
    width: "20px",
    height: "20px",
    border: `5px solid ${theme.palette.primary.main}`,
    boxSizing: "border-box",
    borderRadius: "10px",
  },
}));
